/**
 * Row of equal-width capsule buttons (spec §3.3): selected pill is filled with
 * the tint color and white text; unselected pills are surfaceAlt + ink.
 */
export function Segmented<T extends string>({
  options,
  value,
  tint = "var(--cool)",
  disabled = false,
  onChange
}: {
  options: { value: T; label: string }[];
  value: T | null;
  /** Fill color of the selected pill. */
  tint?: string;
  disabled?: boolean;
  onChange: (value: T) => void;
}) {
  return (
    <div className="segmented" role="group">
      {options.map((option) => {
        const selected = option.value === value;
        return (
          <button
            key={option.value}
            type="button"
            className={`segmented-pill${selected ? " selected" : ""}`}
            style={selected ? { background: tint } : undefined}
            aria-pressed={selected}
            disabled={disabled}
            onClick={() => onChange(option.value)}
          >
            {option.label}
          </button>
        );
      })}
    </div>
  );
}
